import React, { Component, useEffect, useRef } from 'react';
import PlyrJS from 'plyr';
import 'plyr/dist/plyr.css';

class PlyrErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn("Plyr error boundary caught issue:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '16px', textAlign: 'center', color: '#a0aec0', background: 'rgba(0,0,0,0.2)', borderRadius: '8px' }}>
          <span>Reproductor multimedia</span>
        </div>
      );
    }
    return this.props.children;
  }
}

function SafePlyrInner({ source, options }) {
  const mediaRef = useRef(null);
  const playerRef = useRef(null);

  const isAudio = source?.type === 'audio';
  const srcItem = source?.sources?.[0];
  const mediaTitle = options?.title || (isAudio ? 'Reproductor de audio' : 'Reproductor de video');

  useEffect(() => {
    if (!mediaRef.current) return;

    try {
      playerRef.current = new PlyrJS(mediaRef.current, options || {});
    } catch (e) {
      console.warn("Error initializing Plyr:", e);
    }

    return () => {
      if (playerRef.current) {
        try {
          playerRef.current.destroy();
        } catch (e) {
          // Ignore DOM node detachment errors on unmount
        }
        playerRef.current = null;
      }
    };
  }, [srcItem?.src]);

  return (
    <div className="safe-plyr-container" style={{ width: '100%', position: 'relative' }}>
      {isAudio ? (
        <audio ref={mediaRef} controls crossOrigin="anonymous" style={{ width: '100%' }} title={mediaTitle} aria-label={mediaTitle}>
          {srcItem && <source src={srcItem.src} type={srcItem.type} />}
        </audio>
      ) : (
        <video ref={mediaRef} controls crossOrigin="anonymous" playsInline style={{ width: '100%' }} title={mediaTitle} aria-label={mediaTitle}>
          {srcItem && <source src={srcItem.src} type={srcItem.type} />}
        </video>
      )}
    </div>
  );
}

export default function SafePlyr(props) {
  return (
    <PlyrErrorBoundary>
      <SafePlyrInner {...props} />
    </PlyrErrorBoundary>
  );
}
